import { createMachine } from 'xstate';
import { Model } from 'xstate/lib/model.types';
import { BaseContext, BaseEvent, customElement, remoteMessage } from '../../../machine';
import React from 'react';

import { AddToMobileWalletFromGlobalData } from '../ZoryveDirect.components';
import { Link } from '@fluentui/react';

const WELCOME = 'WELCOME';
const ADD_TO_MOBILE_WALLET_EXISTING = 'ADD_TO_MOBILE_WALLET_EXISTING';
const QUESTIONS = 'QUESTIONS';

export const YEAR_END_MESSAGES = {
  WELCOME: (
    <>
      Arcutis Savings Card Program: You have been automatically re-enrolled to ZORYVE Direct for the
      next year. See terms and conditions at:{' '}
      <Link
        style={{ color: 'white' }}
        target="_blank"
        href="https://www.zoryve.com/save-with-zoryve-direct?anchor=terms"
        rel="noreferrer"
      >
        <u>Terms & Conditions.</u>
      </Link>
    </>
  ),
  ADD_TO_MOBILE_WALLET_EXISTING: <AddToMobileWalletFromGlobalData />,
  QUESTIONS:
    'Questions? Call 1-844-979-1288 from 6:00 am–5:00 pm PT, M–F. Text STOP to unsubscribe. Text TERMS for Terms and Conditions to 1-440-496-7983.',
};

/**
 * ZORYVE Direct Program Flow V2.0
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const ZoryveDirectYearEndFlow = (
  model: Model<BaseContext, BaseEvent, void>,
  initial = WELCOME
) =>
  createMachine<BaseContext, BaseEvent>({
    id: 'ZoryveDirectYearEndFlow',
    initial: initial ?? WELCOME,
    context: model.initialContext,
    states: {
      [WELCOME]: remoteMessage({
        id: WELCOME,
        message: YEAR_END_MESSAGES.WELCOME,
        nextState: ADD_TO_MOBILE_WALLET_EXISTING,
      }),

      [ADD_TO_MOBILE_WALLET_EXISTING]: customElement({
        id: ADD_TO_MOBILE_WALLET_EXISTING,
        jsx: YEAR_END_MESSAGES.ADD_TO_MOBILE_WALLET_EXISTING,
        nextState: QUESTIONS,
      }),

      [QUESTIONS]: remoteMessage({
        id: QUESTIONS,
        message: YEAR_END_MESSAGES.QUESTIONS,
      }),
    },
  });
